import { gql } from "@apollo/client";

const LEAGUES_BY_TEAMS = gql`
  query fetchLeaguesByTeamId($teamId: Int!) {
    fetchLeaguesByTeamId(teamId: $teamId) {
      id
      title
      logo
      type
      sports {
        title
      }
      country
    }
  }
`;

export default LEAGUES_BY_TEAMS;
